import React, { useState } from 'react'
import EventsHero from '../../components/events/events-hero'
import Layout from '../../components/system/layout'
import EventListing from '../../components/events/event-listing'
import Meta from '../../components/system/meta'
import { withApollo } from '../../apollo/apollo'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import { EventFragment } from '../../components/events/event-fragment'
import moment from 'moment'
import { LocationsContext, FiltersContext } from '../../components/events/filters'

const EVENTS_QUERY = gql`
  query Events($filter: PACEventFilter) {
    allEvents(filter: $filter) {
      ...PACEvent
    }
    locations(filter: { filterable: true }) {
      id
      name
    }
  }
  ${EventFragment}
`

const initialFilters = {
  venues: [] as { value: string; label: string }[],
  eventTypes: [] as { value: string; label: string }[],
  startDate: null as moment.Moment,
  endDate: null as moment.Moment
}

const Events = (): JSX.Element => {
  const [filters, setFilters] = useState(initialFilters)

  const clearFilters = (): void => {
    setFilters(initialFilters)
  }

  const queryFilter: {
    locations?: string[]
    types?: string[]
    startDate?: string
    endDate?: string
  } = {}
  if (filters.venues && filters.venues.length > 0) {
    queryFilter.locations = filters.venues.map(venue => venue.value)
  }
  if (filters.eventTypes) {
    queryFilter.types = filters.eventTypes.map(type => type.value)
  }
  if (filters.startDate) {
    queryFilter.startDate = filters.startDate.format('MM/DD/YYYY')
  }
  if (filters.endDate) {
    queryFilter.endDate = filters.endDate.format('MM/DD/YYYY')
  }

  const hasVenues = filters.venues && filters.venues.length > 0
  const hasEventTypes = filters.eventTypes && filters.eventTypes.length > 0
  const hasFilters =
    filters !== initialFilters &&
    (hasVenues || hasEventTypes || filters.startDate !== null || filters.endDate !== null)

  const { data, loading, error } = useQuery(EVENTS_QUERY, {
    variables: {
      filter: queryFilter
    }
  })

  const locations = (data && data.locations) || []

  return (
    <LocationsContext.Provider value={locations}>
      <FiltersContext.Provider
        value={{
          state: [filters, setFilters],
          clear: clearFilters,
          hasFilters
        }}
      >
        <Layout>
          <Meta title="Upcoming Events" />
          <EventsHero />
          <EventListing data={data} loading={loading} />
        </Layout>
      </FiltersContext.Provider>
    </LocationsContext.Provider>
  )
}

export default withApollo(Events)
